import $j from 'jquery';
import findIndex from 'lodash/findIndex';
import remove from 'lodash/remove';

const callbacks = [];

export const navigatorOnlineCallback = (key, callback, removeAfterCall = true) => {
  const index = findIndex(callbacks, { key });
  if (index > -1) {
    callbacks[index] = {
      key,
      callback,
      removeAfterCall
    };
  } else {
    callbacks.push({
      key,
      callback,
      removeAfterCall
    });
  }
  console.log('navigator online callbacks:: ', callbacks);
};

export const removeCallback = (key) => {
  remove(callbacks, {
    key
  });
};

export const init = () => {
  $j(window).on('online.noc', () => {
    if (callbacks && callbacks.length > 0) {
      callbacks.forEach((co) => {
        co.callback && co.callback();
      });
      callbacks.forEach((co) => {
        // co.callback && co.callback();
        if (co.removeAfterCall) {
          removeCallback(co.key);
        }
      });
    }
  });
};

init();
